import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQRBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 364,
	height: 473,
	fill: "none",
	viewBox: "0 0 364 473",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#43a9f1",
			d: "m47.3 141.06 31.37.79C99.26 67.7 141 36.2 182.37 35.55 105.74 28.1 63.06 82.1 47.28 141.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint0_linear_27738_4876)",
			fillOpacity: .38,
			d: "M187.79 209.82c54.38-52.56 13.4-82.01-8.82-85.6 7.35-11.19 31.14-26.36 60.55.72 36.75 33.84 12.54 66.84-.27 81.87-6.94 9.91-65.44 43.38-87.04 61.05-11.76 26.26-20.72 61.23-20.72 61.23l-34.38-20.92c5.35-15.1 15.81-46.35 20.38-51.53 13.7-15.54 16.75-5.53 70.3-46.82"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1577bf",
			stroke: "#80a7de",
			strokeWidth: 1.78,
			d: "m78.53 141.33-31.37.16 71.3 26.77 38.87 4.14z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 2.67,
			d: "M131.77 328.25 97.1 308.17c4.27-15.14 14.94-41.52 17.3-46.31 5.55-11.3 18.2-15.84 56.25-39.55 17.76-11.56 52.15-43.2 42.06-69.42-10.67-27.76-31.21-27.85-35-27.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint1_linear_27738_4876)",
			stroke: "#accdff",
			strokeWidth: 1.78,
			d: "M232.44 45.57c-98.74-39.38-143.26 46.92-153.18 95l77.81 31.2c9.37-52.14 44.13-81.59 84.13-46.22 37.74 33.35 5.08 74.67-1.07 81.47-10.18 11.28-41.08 30.21-64.17 43.8-23.09 13.57-22.91 17.37-25.96 22.46-2.46 4.11-13.17 38.37-17.8 55.1l66 15.71c2.32-7.2 3.66-15.18 14.17-33.75s60.76-15.91 89.92-58.4c79.27-115.52-18.56-187.62-69.85-206.37Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 2.67,
			d: "M232.44 45.57c-98.74-39.38-143.26 46.92-153.18 95l77.81 31.2c9.37-52.14 44.13-81.59 84.13-46.22 37.74 33.35 5.08 74.67-1.07 81.47-10.18 11.28-41.08 30.21-64.17 43.8-23.09 13.57-22.91 17.37-25.96 22.46-2.46 4.11-13.17 38.37-17.8 55.1l66 15.71c2.32-7.2 3.66-15.18 14.17-33.75s60.76-15.91 89.92-58.4c79.27-115.52-18.56-187.62-69.85-206.37Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 2.67,
			d: "m131.49 328.6-34.66-20.07c4.27-15.14 14.94-41.52 17.3-46.31 5.55-11.3 18.2-15.84 56.25-39.55 17.76-11.56 52.15-43.2 42.06-69.42-10.67-27.76-31.21-27.85-35-27.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#55a9f9",
			fillOpacity: .43,
			d: "m103.31 376.49-23.93 74.08 73.35 8.86 22.42-69.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 1.78,
			d: "m70.15 350.34-21.82 67.54 31.05 32.7m0 0 23.93-74.1 71.84 13.55-22.42 69.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#8ec9ff",
			d: "m48.69 418.22 21.88-67.74 32.32 25.87-23.93 74.09z",
			opacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0d1c36",
			fillOpacity: .11,
			stroke: "#accdff",
			strokeWidth: 2.67,
			d: "m103.03 375.93-33.17-26.15 65.55 14.17 40.07 26.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 2.67,
			d: "m70.15 350.34-21.82 67.54 31.05 32.7m0 0 23.93-74.1 71.84 13.55-22.42 69.4z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_27738_4876",
			x1: 222.76,
			x2: 170.89,
			y1: 113.12,
			y2: 314.24,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "#fff",
					stopOpacity: .18
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .3,
					stopColor: "#ddd"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fff",
					stopOpacity: .45
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_27738_4876",
			x1: 316.77,
			x2: 77.05,
			y1: 191.17,
			y2: 57.63,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#fff",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fff",
				stopOpacity: .17
			})]
		})] })
	]
});
export default SvgQRBig;
